import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { ShieldCheck, Truck, Lock, Check, Briefcase, Package, Gift } from 'lucide-react';
const IMAGES = {
  packshot: 'https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png',
  singlePack: 'https://cdn.magicpatterns.com/uploads/jXoxfLrGpT48fKFDKM7G8F/Your_paragraph_text_(21).png'
};
const CHECKOUT_URLS = {
  buy1: 'https://glowliftessence.com/cart/46940111569086:1',
  buy2get1: 'https://glowliftessence.com/cart/46940111601854:1',
  buy3get2: 'https://glowliftessence.com/cart/46940111634622:1'
};
export function PricingSection() {
  const goToCheckout = (url: string) => () => {
    window.location.href = url;
  };
  return <section id="pricing" className="py-24 bg-[#FDFBF7]" data-id="element-210">
      <Container data-id="element-211">
        <div className="text-center mb-16" data-id="element-212">
          <h2 className="text-3xl md:text-5xl font-serif text-gray-900 mb-4" data-id="element-213">
            Quiet Sleep Starts Tonight
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-end" data-id="element-214">
          {/* Bundle 1 - 1x */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 flex flex-col items-center relative z-0" data-id="element-215">
            <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="element-216">Buy 1</h3>
            <div className="text-gray-500 mb-6" data-id="element-217">1x SnoreStop™</div>

            <img src={IMAGES.singlePack} alt="1 Pack" className="h-32 object-contain mb-8" data-id="element-218" />

            <div className="mb-8 text-center" data-id="element-219">
              <div className="text-gray-400 line-through text-lg" data-id="element-220">$100.00</div>
              <div className="text-4xl font-serif text-gray-900" data-id="element-221">$49.95</div>
              <div className="inline-block mt-2 text-green-700 font-semibold text-xs bg-green-50 px-2.5 py-1 rounded-full" data-id="element-222">
                Save 50%
              </div>
            </div>

            <Button onClick={goToCheckout(CHECKOUT_URLS.buy1)} fullWidth variant="outline" className="mt-auto" data-id="element-223">
              Select 1-Pack
            </Button>

            <ul className="w-full mt-6 pt-6 border-t border-gray-100 space-y-2.5 text-xs text-gray-600" data-id="element-224">
              <li className="flex items-center" data-id="element-225">
                <ShieldCheck className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-226" />
                60-Night Money Back Guarantee
              </li>
              <li className="flex items-center" data-id="element-227">
                <Truck className="w-4 h-4 mr-2 text-green-600 flex-shrink-0" data-id="element-228" />
                <span data-id="element-229">
                  <span className="font-semibold" data-id="element-230">FREE</span> Worldwide Shipping
                </span>
              </li>
              <li className="flex items-center" data-id="element-231">
                <Briefcase className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-232" />
                Travel Case Included
              </li>
              <li className="flex items-center" data-id="element-233">
                <Lock className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-234" />
                Secure Checkout
              </li>
            </ul>
          </div>

          {/* Bundle 2 - Buy 2 Get 1 Free - Most Popular */}
          <div className="bg-white rounded-2xl shadow-xl border-2 border-[#1E40AF] p-10 flex flex-col items-center relative z-10 transform md:-translate-y-4" data-id="element-235">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#1E40AF] text-white px-6 py-1.5 rounded-full text-sm font-medium tracking-wide whitespace-nowrap" data-id="element-236">
              Most Popular
            </div>

            <h3 className="text-2xl font-serif text-gray-900 mb-2 mt-2" data-id="element-237">
              Buy 2 Get 1 Free
            </h3>
            <div className="text-[#1E40AF] font-medium mb-6" data-id="element-238">
              3x SnoreStop™
            </div>

            <div className="flex justify-center mb-6" data-id="element-239">
              <img src="https://cdn.magicpatterns.com/uploads/3kcdbepp1gXAuijXTVxXyM/Your_paragraph_text_(24).png" alt="Buy 2 Get 1 Free Bundle" className="h-44 object-contain" data-id="element-240" />
            </div>

            <div className="mb-6 text-center" data-id="element-241">
              <div className="text-gray-400 line-through text-xl" data-id="element-242">$300.00</div>
              <div className="text-5xl font-serif text-gray-900" data-id="element-243">$99.95</div>
              <div className="inline-block mt-2 text-green-700 font-semibold text-sm bg-green-50 px-3 py-1 rounded-full" data-id="element-244">
                Save 67%
              </div>
            </div>

            <div className="w-full text-sm text-gray-600 mb-8 text-center bg-blue-50 py-3 rounded-xl" data-id="element-245">
              <span className="font-medium text-gray-900 block mb-1" data-id="element-246">
                Perfect for:
              </span>
              Home • Travel Bag • Backup Replacement
            </div>

            <Button onClick={goToCheckout(CHECKOUT_URLS.buy2get1)} fullWidth variant="primary" size="lg" className="mt-auto" data-id="element-247">
              Select 3-Pack
            </Button>

            <ul className="w-full mt-6 pt-6 border-t border-gray-100 space-y-2.5 text-sm text-gray-700" data-id="element-248">
              <li className="flex items-center" data-id="element-249">
                <Check className="w-4 h-4 mr-2 text-green-600 flex-shrink-0" data-id="element-250" />
                <span data-id="element-251">
                  <span className="font-semibold" data-id="element-252">FREE Worldwide Shipping</span>
                </span>
              </li>
              <li className="flex items-center" data-id="element-253">
                <ShieldCheck className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-254" />
                60-Night Money Back Guarantee
              </li>
              <li className="flex items-center" data-id="element-255">
                <Gift className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-256" />
                Free Sleep Optimization Guide
              </li>
              <li className="flex items-center" data-id="element-257">
                <Briefcase className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-258" />
                3 Travel Cases Included
              </li>
              <li className="flex items-center" data-id="element-259">
                <Package className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-260" />
                In Stock — Ships Within 24 Hours
              </li>
              <li className="flex items-center" data-id="element-261">
                <Lock className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-262" />
                Secure Checkout
              </li>
            </ul>
          </div>

          {/* Bundle 3 - Buy 3 Get 2 Free - Best Value */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 flex flex-col items-center relative z-0" data-id="element-263">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gray-100 text-gray-600 px-4 py-1 rounded-full text-xs font-medium uppercase tracking-wide whitespace-nowrap" data-id="element-264">
              Best Value
            </div>

            <h3 className="text-xl font-medium text-gray-900 mb-2 mt-2" data-id="element-265">
              Buy 3 Get 2 Free
            </h3>
            <div className="text-gray-500 mb-6" data-id="element-266">5x SnoreStop™</div>

            <div className="flex justify-center mb-6" data-id="element-267">
              <img src="https://cdn.magicpatterns.com/uploads/eYgPgdwetfyLiE9RC6RmVj/Your_paragraph_text_(23).png" alt="Buy 3 Get 2 Free Bundle" className="h-40 object-contain" data-id="element-268" />
            </div>

            <div className="mb-6 text-center" data-id="element-269">
              <div className="text-gray-400 line-through text-lg" data-id="element-270">$500.00</div>
              <div className="text-4xl font-serif text-gray-900" data-id="element-271">$149.95</div>
              <div className="inline-block mt-2 text-green-700 font-semibold text-xs bg-green-50 px-2.5 py-1 rounded-full" data-id="element-272">
                Save 70%
              </div>
            </div>

            <div className="w-full text-sm text-gray-600 mb-8 text-center" data-id="element-273">
              Best for couples who want long term uninterrupted sleep support.
            </div>

            <Button onClick={goToCheckout(CHECKOUT_URLS.buy3get2)} fullWidth variant="outline" className="mt-auto" data-id="element-274">
              Select 5-Pack
            </Button>

            <ul className="w-full mt-6 pt-6 border-t border-gray-100 space-y-2.5 text-xs text-gray-600" data-id="element-275">
              <li className="flex items-center" data-id="element-276">
                <Check className="w-4 h-4 mr-2 text-green-600 flex-shrink-0" data-id="element-277" />
                <span className="font-semibold" data-id="element-278">FREE Worldwide Shipping</span>
              </li>
              <li className="flex items-center" data-id="element-279">
                <ShieldCheck className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-280" />
                60-Night Money Back Guarantee
              </li>
              <li className="flex items-center" data-id="element-281">
                <Gift className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-282" />
                Free Sleep Optimization Guide
              </li>
              <li className="flex items-center" data-id="element-283">
                <Briefcase className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-284" />
                5 Travel Cases Included
              </li>
              <li className="flex items-center" data-id="element-285">
                <Lock className="w-4 h-4 mr-2 text-[#1E40AF] flex-shrink-0" data-id="element-286" />
                Secure Checkout
              </li>
            </ul>
          </div>
        </div>

        {/* Trust */}
        <div className="mt-16 text-center" data-id="element-287">
          <div className="flex flex-wrap justify-center gap-8 text-gray-500 text-sm" data-id="element-288">
            <span className="flex items-center" data-id="element-289">
              <Lock className="w-4 h-4 mr-2" data-id="element-290" /> Secure Checkout
            </span>
            <span className="flex items-center" data-id="element-291">
              <ShieldCheck className="w-4 h-4 mr-2" data-id="element-292" /> 60-Night Guarantee
            </span>
            <span className="flex items-center" data-id="element-293">
              <Truck className="w-4 h-4 mr-2" data-id="element-294" /> Fast Shipping
            </span>
          </div>
        </div>
      </Container>
    </section>;
}